// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  loadDirectMerchant,
  setDirectMerchant,
  resetDirectMerchantShow,
  downloadCsv,
  showTooltip
} from './reducer';

import DirectMerchantsFilters from '../DirectMerchantsIndex/DirectMerchantsFilters';
import {
  toggleCalendarFilter,
  clearCalendarFilter,
  setCalendarStartFilter,
  setCalendarEndFilter,
  setCalendarSaga
} from '../DirectMerchantsIndex/reducer/filters';
import {
  type Merchant,
  type Currencies,
  type TooltipProps,
  type Currency
} from '../../../../utilities/types';
import DirectMerchantShowPanel from './DirectMerchantShowPanel';
import { removeShowId } from '../../../Dashboard/Referrals/reducer';
import { getPartnerCurrency } from '../../../../utilities/selectors';
import { dig } from '../../../../utilities/misc';

type Props = {
  loadDirectMerchant: (value: ?number) => void,
  directMerchant: Merchant,
  currencies: Currencies,
  search: string,
  setSearchFilter: (value: string) => void,
  statusFilter: ?string,
  setStatusFilter: (value: string) => void,
  toggleCalendarFilter: () => void,
  calendarFilterState: boolean,
  startDate?: string,
  endDate?: string,
  clearCalendarFilter: () => void,
  setCalendarStartFilter: (date: ?moment$Moment) => void,
  setCalendarEndFilter: (date: ?moment$Moment) => void,
  downloadCsv: () => void,
  setCalendarSaga: () => void,
  loading: boolean,
  match: {
    params: {
      id: number
    }
  },
  viewportDevice: string,
  showMostRecentOnly?: boolean,
  showId?: number,
  removeShowId: () => void,
  resetDirectMerchantShow: () => void,
  ...$Exact<TooltipProps>,
  totalProcessingVolUsd: string,
  totalFeesUsd: string,
  partnerCurrency: Currency
};

class DirectMerchantShow extends Component<Props> {
  componentDidMount() {
    if (this.props.showMostRecentOnly) {
      this.props.loadDirectMerchant(this.props.showId);
    } else {
      this.props.loadDirectMerchant(this.props.match.params.id);
    }
  }
  componentWillUnmount() {
    this.props.resetDirectMerchantShow();
  }
  handleClose = () => {
    this.props.removeShowId();
  };
  render() {
    const availableMerchantStatusOptions = [
      { text: 'New', value: 'new' },
      { text: 'Partially Filled', value: 'partially_filled' },
      { text: 'Pending', value: 'pending' },
      { text: 'Denied', value: 'denied' },
      { text: 'Approved', value: 'approved' }
    ];
    return (
      <>
        {!this.props.showMostRecentOnly && (
          <DirectMerchantsFilters
            // Search Filter Props
            searchValue={this.props.search}
            setSearchFilter={this.props.setSearchFilter}
            // Status Filter Props
            status={this.props.statusFilter}
            setStatusFilter={this.props.setStatusFilter}
            availableStatuses={availableMerchantStatusOptions}
            // Download CSV
            downloadCsv={this.props.downloadCsv}
            // Date Filter
            toggleCalendarFilter={this.props.toggleCalendarFilter}
            calendarFilterState={this.props.calendarFilterState}
            calendarStart={this.props.startDate}
            calendarEnd={this.props.endDate}
            clearCalendarFilter={this.props.clearCalendarFilter}
            setCalendarStartFilter={this.props.setCalendarStartFilter}
            setCalendarEndFilter={this.props.setCalendarEndFilter}
            windowSize={this.props.viewportDevice}
            setCalendarSaga={this.props.setCalendarSaga}
            disabled={true}
          />
        )}
        <DirectMerchantShowPanel
          loading={this.props.loading}
          currencies={this.props.currencies}
          directMerchant={this.props.directMerchant}
          showMostRecentOnly={this.props.showMostRecentOnly}
          handleClick={this.handleClose}
          showTooltip={this.props.showTooltip}
          totalProcessingVolUsd={this.props.totalProcessingVolUsd}
          totalFeesUsd={this.props.totalFeesUsd}
          partnerCurrency={this.props.partnerCurrency}
          activeTooltip={this.props.activeTooltip}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.merchants.directMerchants.show.loading,
  directMerchant: state.merchants.directMerchants.show.directMerchant,
  search: state.merchants.directMerchants.index.filters.search,
  statusFilter: state.merchants.directMerchants.index.filters.status,
  calendarFilterState:
    state.merchants.directMerchants.index.filters.calendarFilterState,
  startDate: state.merchants.directMerchants.index.filters.startDate,
  endDate: state.merchants.directMerchants.index.filters.endDate,
  currencies: state.global.currencies,
  viewportDevice: state.global.viewportDevice,
  showId: state.dashboard.referrals.showId,

  totalProcessingVolUsd: dig(
    state.merchants.directMerchants.show.directMerchant,
    'total_processing_vol_usd'
  ),
  totalFeesUsd: dig(
    state.merchants.directMerchants.show.directMerchant,
    'total_fees_usd'
  ),
  partnerCurrency: getPartnerCurrency(state),
  activeTooltip: state.partners.referredPartners.show.activeTooltip
});

const mapDispatchToProps = {
  downloadCsv,
  loadDirectMerchant,
  setDirectMerchant,
  toggleCalendarFilter,
  clearCalendarFilter,
  setCalendarStartFilter,
  setCalendarEndFilter,
  setCalendarSaga,
  resetDirectMerchantShow,
  removeShowId,
  showTooltip
};

export default connect(mapStateToProps, mapDispatchToProps)(DirectMerchantShow);
